import { apiCaller } from '@/api/apiCaller';
import { IUserType } from '@/modules/user-type/models';
import { apihost } from '@/api/urls';

const getAll = () => apiCaller.get('/usertype/', apihost);
const addUserType = (userType: IUserType) => apiCaller.post('/usertype/save', apihost, userType);
const updateUserType = (userType: IUserType) =>  apiCaller.put('/usertype/update', apihost, userType);

export const userTypeApi = {
  getAll,
  addUserType,
  updateUserType,
};
